import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import type { GetPublicBlogPostQuery } from 'apollo-gql'
import { PREFETCH_PUBLIC_BLOG_POST } from 'graphql/queries/getPublicBlogPostQuery'
import { currentLanguageIdVar, currentMarketIdVar } from 'graphql/reactive'

const prefetchBlogPost = async (
  apolloClient: ApolloClient<NormalizedCacheObject>,
  variables: { slug: string | string[] },
): Promise<GetPublicBlogPostQuery['market']['blogPost'] | undefined> => {
  const marketId = currentMarketIdVar()
  const languageId = currentLanguageIdVar()

  if (marketId && languageId) {
    const response = await apolloClient.query<GetPublicBlogPostQuery>({
      query: PREFETCH_PUBLIC_BLOG_POST,
      variables: {
        marketId,
        languageId,
        ...variables,
      },
    })

    return response.data?.market?.blogPost
  }

  return undefined
}

export default prefetchBlogPost
